import React from 'react';
import "./skills.css";
import "./skills.scss";
import { SiTailwindcss, SiTypescript, SiHtml5, SiCss3, SiJavascript, SiReact } from 'react-icons/si';
import { RiNextjsFill } from "react-icons/ri";

const Frontend = () => {
  return (
    <div className="skills__content box-top-left">
        <h3 className="skills__title">Frontend</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <SiReact size={20} />
                    <div>
                        <h3 className="skills__name">React</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <RiNextjsFill size={20} />
                    <div>
                        <h3 className="skills__name">Next.js</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiTypescript size={20} />
                    <div>
                        <h3 className="skills__name">TypeScript</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                    <SiJavascript size={20} />
                    <div>
                        <h3 className="skills__name">JavaScript</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiTailwindcss size={20} />
                    <div>
                        <h3 className="skills__name">Tailwind CSS</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiHtml5 size={20} />
                    <div>
                        <h3 className="skills__name">HTML/CSS</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Frontend